import { FC } from 'react';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import { useTranslation } from '@frontend/i18n';
import { Text, useTooltip } from '@frontend/design-system';

dayjs.extend(calendar);

export type LastUpdatedInfoProps = {
  lastUpdatedAt: string | Date | number;
  tooltipText?: string;
};

export const LastUpdatedInfo: FC<LastUpdatedInfoProps> = ({ lastUpdatedAt, tooltipText }) => {
  const { t } = useTranslation('ai-receptionist-settings');
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({ placement: 'top' });

  const formattedDate = dayjs(lastUpdatedAt).calendar(null, {
    sameDay: '[Today]',
    lastDay: '[Yesterday]',
    lastWeek: 'MM/DD/YYYY',
    sameElse: 'MM/DD/YYYY',
  });

  return (
    <>
      <div {...triggerProps} css={styles.container}>
        <Text size='medium' color='subdued'>
          {formattedDate}
        </Text>
      </div>
      <Tooltip {...tooltipProps}>{tooltipText || t('Page last updated')}</Tooltip>
    </>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    cursor: default;
  `,
};
